import createHistory from 'history/createBrowserHistory'
import thunkMiddleware from 'redux-thunk'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { createLogger } from 'redux-logger'

import apiMiddleware from '../middleware/api'
import authReducer from '../reducers/auth'
import contractsReducer from '../reducers/contracts'
import customersReducer from '../reducers/customers'
import incidencesReducer from '../reducers/incidences'
import itemsReducer from '../reducers/items'
import MachinesReducer from '../reducers/machines'
import MinisReducer from '../reducers/minis'
import salesReducer from '../reducers/sales'
import usersReducer from '../reducers/users'
import remoteActionsReducer from '../reducers/remoteactions'
import updatesReducer from '../reducers/updates'
import shipmentsReducer from '../reducers/shipments'
import auditsReducer from '../reducers/audits'
import shiftsReducer from '../reducers/shifts'
import promoterSalesReducer from '../reducers/promotersales'
import matrixsReducer from '../reducers/matrixs'
import arqueosReducer from '../reducers/arqueos'
import promotersReducer from '../reducers/promoters'
import modulesReducer from '../reducers/modules'
import objectivesReducer from '../reducers/objectives'
import universalupdatesReducer from '../reducers/universalupdates'
import supportticketsReducer from '../reducers/supporttickets'
import slasReducer from '../reducers/slas'
import bowlerReducer from '../reducers/bowler'
import syncReducer from '../reducers/sync'
import proposalsReducer from '../reducers/proposals'
import proposalCatalogReducer from '../reducers/proposalCatalog'

import { AUTH_LOGOUT, AUTH_LOGIN_SUCCESS } from '../actions/auth'
import currencyReducer from '../reducers/currency'
import { initCurrency } from '../actions/currency'
import { setActiveCurrency, writeStoredDefault, writeStoredOverride } from '../utils/currency'

export const history = createHistory()

const myRouterMiddleware = routerMiddleware(history)
const loggerMiddleware = createLogger()

const appReducer = combineReducers({
  auth: authReducer,
  contracts: contractsReducer,
  customers: customersReducer,
  incidences: incidencesReducer,
  items: itemsReducer,
  machines: MachinesReducer,
  minis: MinisReducer,
  sales: salesReducer,
  users: usersReducer,
  remoteactions: remoteActionsReducer,
  updates: updatesReducer,
  shipments: shipmentsReducer,
  audits: auditsReducer,
  shifts: shiftsReducer,
  promoterSales: promoterSalesReducer,
  matrixs: matrixsReducer,
  arqueos: arqueosReducer,
  promoters: promotersReducer,
  modules: modulesReducer,
  objectives: objectivesReducer,
  universalupdates: universalupdatesReducer,
  supporttickets: supportticketsReducer,
  slas: slasReducer,
  bowler: bowlerReducer,
  sync: syncReducer,
  proposals: proposalsReducer,
  proposalCatalog: proposalCatalogReducer,
  currency: currencyReducer,
  form: formReducer,
  router: routerReducer
})

const rootReducer = (state, action) => {
  if (action.type === AUTH_LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
};

// Currency middleware — arranca la divisa de visualización tras cada login:
// fresh (login real) descarta la elección manual previa y vuelve a la divisa
// de la ficha del cliente; sesión restaurada (fromStorage) la respeta.
const currencyMiddleware = store => next => action => {
  const result = next(action)
  if (action.type === AUTH_LOGIN_SUCCESS) {
    const { auth } = store.getState()
    store.dispatch(initCurrency(auth.id, auth.role, !action.fromStorage))
  }
  return result
}

const middleware = process.env.NODE_ENV === 'production' ?
  applyMiddleware(
    thunkMiddleware,
    apiMiddleware,
    currencyMiddleware,
    myRouterMiddleware
  ) :
  applyMiddleware(
    thunkMiddleware,
    apiMiddleware,
    currencyMiddleware,
    myRouterMiddleware,
    loggerMiddleware
  )

export const store = createStore(rootReducer, middleware);

// Sincroniza la copia síncrona de utils/currency.js (usada por los helpers de
// formato) y persiste por usuario la divisa por defecto cacheada y la elección
// manual. Único punto de efectos secundarios del slice currency.
let lastCurrency = null
store.subscribe(() => {
  const c = store.getState().currency
  if (c === lastCurrency) return
  const prev = lastCurrency
  lastCurrency = c
  if (!prev || prev.code !== c.code) setActiveCurrency(c.code)
  if (c.authId && (!prev || prev.defaultCode !== c.defaultCode)) writeStoredDefault(c.authId, c.defaultCode)
  if (c.authId && c.source === 'user' && (!prev || prev.code !== c.code || prev.source !== c.source)) writeStoredOverride(c.authId, c.code)
})
